const Mutations = Object.freeze({
	SET_SELECTED_REPORT_PREVIEW:
		'reportsModule/reportGrid/SET_SELECTED_REPORT_PREVIEW',
	SET_REPORT: 'reportsModule/reportGrid/SET_REPORT',
	SET_GRID_VIEW: 'reportsModule/reportGrid/SET_GRID_VIEW',
	SET_QUICK_FILTER: 'reportsModule/reportGrid/SET_QUICK_FILTER',
	SET_ADVANCED_FILTER: 'reportsModule/reportGrid/SET_ADVANCED_FILTER',
	SET_SORTING: 'reportsModule/reportGrid/SET_SORTIGN',
	SET_ROWS_PER_PAGE: 'reportsModule/reportGrid/SET_ROWS_PER_PAGE',
	SET_PAGE: 'reportsModule/reportGrid/SET_PAGE',
	SET_COLUMNS: 'reportsModule/reportGrid/SET_COLUMNS',
	SET_LOADING: 'reportsModule/reportGrid/SET_LOADING',
	SET_GRID_DATA: 'reportsModule/reportGrid/SET_GRID_DATA',
	SET_IRIS_USER_METADATA: 'reportsModule/reportGrid/SET_IRIS_USER_METADATA',
	SET_TOTAL_COUNT: 'reportsModule/reportGrid/SET_TOTAL_COUNT',
});

export const Actions = Object.freeze({
	CLEAR: 'reportsModule/reportGrid/CLEAR',
	LOAD_REPORT_PREVIEW: 'reportsModule/reportGrid/LOAD_REPORT_PREVIEW',
	LOAD_GRID_DATA: 'reportsModule/reportGrid/LOAD_GRID_DATA',
	APPLY_QUICK_FILTER: 'reportsModule/reportGrid/APPLY_QUICK_FILTER',
	APPLY_ADVANCED_FILTER: 'reportsModule/reportGrid/APPLY_ADVANCED_FILTER',
	CLEAR_ADVANCED_FILTER: 'reportsModule/reportGrid/CLEAR_ADVANCED_FILTER',
	UPDATE_ROWS_PER_PAGE: 'reportsModule/reportGrid/UPDATE_ROWS_PER_PAGE',
	UPDATE_PAGE: 'reportsModule/reportGrid/UPDATE_PAGE',
	UPDATE_SORTING: 'reportsModule/reportGrid/UPDATE_SORTING',
	UPDATE_QUICK_FILTER: 'reportsModule/reportGrid/UPDATE_QUICK_FILTER',
	UPDATE_ADVANCED_FILTER: 'reportsModule/reportGrid/UPDATE_ADVANCED_FILTER',

	EXPORT_CURRENT_PAGE: 'reportsModule/reportGrid/EXPORT_CURRENT_PAGE', //TODO
	EXPORT_ALL_DATA: 'reportsModule/reportGrid/EXPORT_ALL_DATA', //TODO
	ADD_GRIDVIEW: 'reportsModule/reportGrid/ADD_GRIDVIEW',
	UPDATE_GRIDVIEW: 'reportsModule/reportGrid/UPDATE_GRIDVIEW',
	UPDATE_GRID_VIEW_FIELDS: 'reportsModule/reportGrid/UPDATE_GRID_VIEW_FIELDS',
});
export const Getters = Object.freeze({
	SELECTED_REPORT_PREVIEW: 'reportsModule/reportGrid/SELECTED_REPORT_PREVIEW',
	GRIDVIEW: 'reportsModule/reportGrid/SELECTED_REPORT_PREVIEW',
	PAGE: 'reportsModule/reportGrid/PAGE',
	ROWS_PER_PAGE: 'reportsModule/reportGrid/ROWS_PER_PAGE',
	VISIBLE_COLUMNS: 'reportsModule/reportGrid/VISIBLE_COLUMNS',
	HIDDEN_COLUMNS: 'reportsModule/reportGrid/HIDDEN_COLUMNS',
	TOTAL_COUNT: 'reportsModule/reportGrid/TOTAL_COUNT',
	GRID_DATA: 'reportsModule/reportGrid/GRID_DATA',
	IRIS_USER_METADATA: 'reportsModule/reportGrid/IRIS_USER_METADATA',
	GRID_LOADING: 'reportsModule/reportGrid/GRID_LOADING',
	SORTING: 'reportsModule/reportGrid/SORTING',
	QUICK_FILTER: 'reportsModule/reportGrid/QUICK_FILTER',
	ADVANCED_FILTER: 'reportsModule/reportGrid/ADVANCED_FILTER',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/reportBuilderService';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';

export default {
	state: {
		selectedReportPreview: null,
		reportId: null,
		gridView: null,
		quickFilter: { FieldId: null, Value: '' },
		advancedFilter: { Operator: 1, Filters: [], FiltersCount: 0 },
		sorting: [],
		rowsPerPage: 50,
		page: 1,
		columns: [],
		loading: false,
		gridData: [],
		irisUsersMetadata: [],
		totalCount: 0,
	},

	mutations: {
		[Mutations.SET_SELECTED_REPORT_PREVIEW](state, item) {
			state.selectedReportPreview = item;
		},
		[Mutations.SET_REPORT_ID](state, item) {
			state.reportId = item;
		},
		[Mutations.SET_GRID_VIEW](state, item) {
			state.gridView = item;
		},
		[Mutations.SET_QUICK_FILTER](state, item) {
			state.quickFilter = item;
		},
		[Mutations.SET_ADVANCED_FILTER](state, item) {
			state.advancedFilter = item;
			state.advancedFilter.FiltersCount = item.Filters.length;
		},
		[Mutations.SET_SORTING](state, item) {
			state.sorting = item;
		},
		[Mutations.SET_ROWS_PER_PAGE](state, value) {
			state.rowsPerPage = value;
		},
		[Mutations.SET_PAGE](state, value) {
			state.page = value;
		},
		[Mutations.SET_COLUMNS](state, items) {
			state.columns = items;
		},
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_GRID_DATA](state, items) {
			state.gridData = items;
		},
		[Mutations.SET_IRIS_USER_METADATA](state, items) {
			state.irisUsersMetadata = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, value) {
			state.totalCount = value;
		},
	},

	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_SELECTED_REPORT_PREVIEW, null);
				commit(Mutations.SET_GRID_DATA, null);
				commit(Mutations.SET_IRIS_USER_METADATA, []);
				commit(Mutations.SET_TOTAL_COUNT, 0);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_ROWS_PER_PAGE, 50);
				commit(Mutations.SET_LOADING, false);
				commit(Mutations.SET_SORTING, []);
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: 1,
					Filters: [],
					FiltersCount: 0,
				});
				commit(Mutations.SET_QUICK_FILTER, {
					FieldId: null,
					Value: '',
				});
				commit(Mutations.SET_COLUMNS, []);
				commit(Mutations.SET_GRID_VIEW, null);
				commit(Mutations.SET_REPORT, null);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD_REPORT_PREVIEW](
			{ commit, dispatch, state },
			{ reportId, gridViewId }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getReportPreview(reportId, gridViewId)
					.then((resp) => {
						if (resp.data)
							commit(
								Mutations.SET_SELECTED_REPORT_PREVIEW,
								resp.data
							);
						if (resp.data && resp.data.Report)
							commit(Mutations.SET_REPORT, resp.data.Report);

						if (resp.data && resp.data.GridView)
							commit(Mutations.SET_GRID_VIEW, resp.data.GridView);
						if (
							resp.data &&
							resp.data.GridView &&
							resp.data.GridView.Columns
						) {
							let cols = [];
							resp.data.GridView.Columns.forEach((col) => {
								if (!state.selectedReportPreview.Report) return;
								if (!state.selectedReportPreview.Report.Fields)
									return;
								let reportField =
									state.selectedReportPreview.Report.Fields.find(
										(x) => x.GridViewFieldId == col.Id
									);
								if (reportField && reportField.Label) {
									col.Label = reportField.Label;
								}
								cols.push(col);
							});
							commit(Mutations.SET_COLUMNS, cols);
						}
						/* if (resp.data && resp.data.GridView && resp.data.GridView.AdvancedFilter) {
                        commit(Mutations.SET_ADVANCED_FILTER, { Operator: resp.data.GridView.AdvancedFilterOperator || 1, Filters: resp.data.GridView.AdvancedFilter || [] });
                    }
                    if (resp.data && resp.data.GridView && resp.data.GridView.Sorting) commit(Mutations.SET_SORTING, resp.data.GridView.Sorting);*/
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.LOAD_GRID_DATA]({ commit, dispatch, state }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				let payload = {
					ReportId: state.selectedReportPreview.ReportId,
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.map((x) => x.Id),
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				dataService
					.loadReportPreviewData(payload)
					.then((resp) => {
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(Mutations.SET_GRID_DATA, resp.data.Data);
						commit(
							Mutations.SET_IRIS_USER_METADATA,
							resp.data.IrisUsers
						);
						commit(Mutations.SET_LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve(false);
					});
			});
		},

		[Actions.UPDATE_PAGE]({ commit, dispatch }, value) {
			commit(Mutations.SET_PAGE, value);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_ROWS_PER_PAGE]({ commit, dispatch }, value) {
			commit(Mutations.SET_ROWS_PER_PAGE, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_SORTING]({ commit, dispatch }, value) {
			commit(Mutations.SET_SORTING, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_QUICK_FILTER]({ commit, dispatch }, value) {
			commit(Mutations.SET_QUICK_FILTER, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_ADVANCED_FILTER]({ commit, dispatch }, value) {
			commit(Mutations.SET_ADVANCED_FILTER, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},

		[Actions.UPDATE_GRID_VIEW_FIELDS]({ commit, dispatch, state }, value) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let gridViewId = state.gridView.Id;
				let columns = value.map(({ Id, Order, IsVisible }) => ({
					Id,
					Order,
					IsVisible,
				}));
				dataService
					.updateColumns(gridViewId, columns)
					.then((resp) => {
						let gridView = resp.data;
						commit(Mutations.SET_GRID_VIEW, gridView);
						commit(Mutations.SET_COLUMNS, gridView.Columns);
						dispatch(Actions.LOAD_GRID_DATA);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.ADD_GRIDVIEW]({ commit, dispatch, state }, payload) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				//SaveViewDialog sends { Name, IsGlobal }, report previews only care about the name
				let view =
					typeof payload === 'string' ? { Name: payload } : payload;
				let columns = state.columns.map(({ Id, Order }) => ({
					Id,
					Order,
				}));
				let gridView = {
					Name: view.Name,
					RowsPerPage: state.rowsPerPage,
					EntityId: state.gridView.EntityId,
					Columns: columns,
					AdvancedFilter: state.advancedFilter,
					Sorting: state.sorting,
				};
				let reportId = state.selectedReportPreview.ReportId;
				dataService
					.insertReportPreview({
						ReportId: reportId,
						GridView: gridView,
					})
					.then((resp) => {
						commit(Mutations.SET_GRID_DATA, null);
						commit(Mutations.SET_IRIS_USER_METADATA, []);
						commit(Mutations.SET_TOTAL_COUNT, 0);
						commit(Mutations.SET_PAGE, 1);
						commit(Mutations.SET_ROWS_PER_PAGE, 50);
						commit(Mutations.SET_LOADING, false);
						commit(Mutations.SET_SORTING, []);
						commit(Mutations.SET_ADVANCED_FILTER, {
							Operator: 1,
							Filters: [],
						});
						commit(Mutations.SET_QUICK_FILTER, {
							FieldId: null,
							Value: '',
						});
						commit(Mutations.SET_COLUMNS, []);
						commit(Mutations.SET_GRID_VIEW, null);
						commit(Mutations.SET_SELECTED_REPORT_PREVIEW, null);

						if (resp.data)
							commit(
								Mutations.SET_SELECTED_REPORT_PREVIEW,
								resp.data
							);
						if (resp.data && resp.data.GridView)
							commit(Mutations.SET_GRID_VIEW, resp.data.GridView);
						if (
							resp.data &&
							resp.data.GridView &&
							resp.data.GridView.Columns
						) {
							let cols = [];
							resp.data.GridView.Columns.forEach((col) => {
								if (!state.selectedReportPreview.Report) return;
								if (!state.selectedReportPreview.Report.Fields)
									return;
								let reportField =
									state.selectedReportPreview.Report.Fields.find(
										(x) => x.GridViewFieldId == col.Id
									);
								if (reportField && reportField.Label) {
									col.Label = reportField.Label;
								}
								cols.push(col);
							});
							commit(Mutations.SET_COLUMNS, cols);
						}
						if (
							resp.data &&
							resp.data.GridView &&
							resp.data.GridView.AdvancedFilter
						) {
							commit(Mutations.SET_ADVANCED_FILTER, {
								Operator:
									resp.data.GridView.AdvancedFilterOperator ||
									1,
								Filters:
									resp.data.GridView.AdvancedFilter || [],
							});
						}
						if (
							resp.data &&
							resp.data.GridView &&
							resp.data.GridView.Sorting
						)
							commit(
								Mutations.SET_SORTING,
								resp.data.GridView.Sorting
							);
						return dispatch(Actions.LOAD_GRID_DATA);
					})
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_GRIDVIEW]({ dispatch, state }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let gridView = {
					Id: state.gridView.Id,
					Name: state.gridView.Name,
					RowsPerPage: state.rowsPerPage,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.sort((a, b) => a.Order - b.Order)
						.map((x) => x.Id),
					AdvancedFilter: state.advancedFilter,
					Sorting: state.sorting,
				};
				dataService
					.updateGridView(gridView)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT_CURRENT_PAGE]({ dispatch, state }, value) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.sort((a, b) => a.Order - b.Order)
						.map((x) => x.Id),
					TimeZone: value,
				};
				let reportId;
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				if (state.selectedReportPreview) {
					reportId = state.selectedReportPreview.ReportId;
					payload.ReportId = reportId;
				}
				exportDataService
					.downloadReportPreviewDirect(reportId, payload)
					.then((resp) => {
						const serverFilename =
							fileUtils.extractFileNameFromResponse(resp);
						const filename =
							serverFilename ||
							`${state.gridView.Entity.Name}_Report_VisibleData_${
								state.gridView.Name
							}_${new Date()
								.toISOString()
								.slice(0, 19)
								.replace(/:/g, '-')}.xlsx`;

						const blob = new Blob([resp.data], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);

						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT_ALL_DATA]({ dispatch, state }, value) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.totalCount,
					Page: 1,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.sort((a, b) => a.Order - b.Order)
						.map((x) => x.Id),
					TimeZone: value,
				};
				let reportId;
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				if (state.selectedReportPreview) {
					reportId = state.selectedReportPreview.ReportId;
					payload.ReportId = reportId;
				}
				exportDataService
					.downloadReportPreviewDirect(reportId, payload)
					.then((resp) => {
						const serverFilename =
							fileUtils.extractFileNameFromResponse(resp);
						const filename =
							serverFilename ||
							`${state.gridView.Entity.Name}_Report_${
								state.gridView.Name
							}_${new Date()
								.toISOString()
								.slice(0, 19)
								.replace(/:/g, '-')}.xlsx`;

						const blob = new Blob([resp.data], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);

						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},

	getters: {
		[Getters.SELECTED_REPORT_PREVIEW]: (state) => {
			if (!state.selectedReportPreview) return null;
			return JSON.parse(JSON.stringify(state.selectedReportPreview));
		},
		[Getters.GRIDVIEW]: (state) => {
			if (!state.selectedReportPreview) return null;
			if (!state.selectedReportPreview.GridView) return null;
			return JSON.parse(
				JSON.stringify(state.selectedReportPreview.GridView)
			);
		},
		[Getters.PAGE]: (state) => {
			return state.page;
		},
		[Getters.ROWS_PER_PAGE]: (state) => {
			return state.rowsPerPage;
		},
		[Getters.VISIBLE_COLUMNS]: (state) => {
			if (!state.columns) return [];
			let visibleColumns = state.columns
				.filter((x) => x.IsVisible === true)
				.sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(visibleColumns));
		},
		[Getters.HIDDEN_COLUMNS]: (state) => {
			if (!state.columns) return [];
			let hiddenColumns = state.columns
				.filter((x) => x.IsVisible === false)
				.sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(hiddenColumns));
		},
		[Getters.TOTAL_COUNT]: (state) => {
			return state.totalCount;
		},
		[Getters.GRID_DATA]: (state) => {
			if (!state.gridData) return [];
			return JSON.parse(JSON.stringify(state.gridData));
		},
		[Getters.SORTING]: (state) => {
			return JSON.parse(JSON.stringify(state.sorting));
		},
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.QUICK_FILTER]: (state) => {
			return JSON.parse(JSON.stringify(state.quickFilter));
		},
		[Getters.ADVANCED_FILTER]: (state) => {
			return JSON.parse(JSON.stringify(state.advancedFilter));
		},
		[Getters.IRIS_USER_METADATA]: (state) => {
			if (!state.irisUsersMetadata) return [];
			if (state.irisUsersMetadata.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.irisUsersMetadata));
		},
	},
};
